import styled from "styled-components";

export const ContainerVentas = styled.div`
    height: 100%;
    width: 100%;
`;

export const Total = styled.div`
    width: 120px;
    height: 80px;
    background-color:#F09999 ;
    margin: 20px;
    
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    border-radius: 12px;

    align-self: flex-start;

    font-size: 1.5rem;

    :nth-child(2){
        font-weight: bold;
    }
`;